import React, {Component} from 'react';
import {Modal, Table} from 'antd';
import moment from 'moment';
import {
  queryIncCustomBusinessOregistapp,
  queryIncCustomBusinessSettled,
  queryIncCustomSettled,
} from '@api/incubator/custom';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settledList: [],
      selectedRowKeys: props.selectedRowKeys || [],
      selectedRows: props.selectedRows || [],
      total: 0,
      pageSize: 5,
    };
  }

  componentDidMount() {
    this.load(1);
  }

  load = pageNo => {
    const { type } = this.props;
    if (type === 'oregistapp') {
      this.getIncCustomBusinessOregistapp(pageNo);
    } else if (type === 'settled') {
      this.getIncCustomBusinessSettled(pageNo);
    } else {
      this.getIncCustomSettled(pageNo);
    }
  };

  getIncCustomBusinessSettled = pageNo => {
    this.setState({ loading: true });
    const pageSize = 5;
    const current = pageNo || 0;

    queryIncCustomBusinessSettled({
        customUuid: this.props.customUuid,
        // incubatorUuid: this.props.incubatorUuid,
        start: current,
        limit: pageSize,
      })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            settledList: res.data,
            total: res.totalSize,
            pageSize: pageSize || 5,
          });
        }
        this.setState({ loading: false });
      });
  };

  getIncCustomSettled = pageNo => {
    this.setState({ loading: true });
    const pageSize = 5;
    const current = pageNo || 0;

    queryIncCustomSettled({
        customUuid: this.props.customUuid,
        // incubatorUuid: this.props.incubatorUuid,
        start: current,
        limit: pageSize,
      })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            settledList: res.data,
            total: res.totalSize,
            pageSize: pageSize || 5,
          });
        }
        this.setState({ loading: false });
      });
  };

  getIncCustomBusinessOregistapp = pageNo => {
    this.setState({ loading: true });
    const pageSize = 5;
    const current = pageNo || 0;

    queryIncCustomBusinessOregistapp({
        customUuid: this.props.customUuid,
        incubatorUuid: this.props.incubatorUuid,
        start: current,
        limit: pageSize,
      })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            settledList: res.data,
            total: res.totalSize,
            pageSize: pageSize || 5,
          });
        }
        this.setState({ loading: false });
      });
  };

  columns = () => {
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        render: (text, record) => (
          <a onClick={() => this.props.changePage(record.businessUuid)}>{record.no}</a>
        ),
      },
      {
        title: '合同周期',
        dataIndex: 'beginDate',
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
    ];
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.selectedRows = selectedRows;
    this.setState({ selectedRowKeys, selectedRows });
  };

  handleOk = () => {
    const { selectedRowKeys, selectedRows } = this.state;
    if (selectedRowKeys.length > 0) {
      const selectedRowsFormat = selectedRows.map(item => {
        const selecteItem = { ...item, uuid: item.businessUuid || item.uuid };
        return selecteItem;
      });
      this.props.onOk(selectedRowKeys, selectedRowsFormat);
      this.props.handleCancel(false);
    }
  };

  render() {
    const { visible, handleCancel } = this.props;
    const { loading, total, pageSize, settledList, selectedRowKeys } = this.state;
    const pagination = {
      total,
      showSizeChanger: false,
      pageSize,
      onChange: current => {
        this.load(current);
      },
    };
    const rowSelection = {
      onChange: this.onSelectChange,
      selectedRowKeys,
    };
    return (
      <Modal
        title="基础孵化合同信息"
        visible={visible}
        onCancel={() => handleCancel(false)}
        width={680}
        onOk={this.handleOk}
      >
        <Table
          loading={loading}
          rowKey="businessUuid"
          columns={this.columns()}
          dataSource={settledList}
          pagination={pagination}
          rowSelection={rowSelection}
        />
      </Modal>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/comm/ModalRenew.js